import http from '../../../http'

const state = {
    userList: [],
    page: {
        current: 1,
        pageSize: 15,
        pageSizes: [15,30,50,100],
        total: 0
    }
};

const mutations = {
    SET_USER_DATE: (state, data) => {
        state.userList = data.records;
        state.page.total = data.total;
        state.page.current = data.current;
        state.page.size = data.size;
    },
    SET_PAGE_CURRENT(state, current) {
        state.page.current = current;
    },
    SET_PAGE_SIZE(state, pageSize) {
        state.page.pageSize = pageSize;
    },
};

const actions = {
    listPage({dispatch, commit}, params) {
        params.current = state.page.current;
        params.size = state.page.pageSize;
        return new Promise(((resolve, reject) => {
            http.post('/supplier-resource/system/user/listPage',params).then((res) => {
                if (res.data.code === '200') {
                    commit('SET_USER_DATE',res.data.data);
                }
                resolve(res.data);
            });
        }));
    },
    setPageCurrent({dispatch, commit}, pageNum) {
        commit('SET_PAGE_CURRENT', pageNum);
    },
    setPageSize({dispatch, commit}, pageSize) {
        commit('SET_PAGE_SIZE', pageSize);
    },
    save({dispatch, commit}, params) {
        return new Promise(((resolve, reject) => {
            http.fileUpload2('/supplier-resource/system/user/doSave',params).then((res) => {
                resolve(res.data);
            });
        }));
    },
    changePwd({dispatch, commit}, params) {
        return new Promise(((resolve, reject) => {
            http.post('/supplier-resource/system/user/changePwd',params).then((res) => {
                resolve(res.data);
            });
        }));
    },

    changeUserInfo({dispatch, commit}, params) {
        return new Promise(((resolve, reject) => {
            http.fileUpload2('/supplier-resource/system/user/changeUserInfo',params).then((res) => {
                resolve(res.data);
            });
        }));
    },

    forceModifyPwd({dispatch, commit}, params) {
        return new Promise(((resolve, reject) => {
            http.post('/supplier-resource/system/user/forceModifyPwd',params).then((res) => {
                resolve(res.data);
            });
        }));
    },

    delete({dispatch, commit}, params) {
        return new Promise(((resolve, reject) => {
            http.post('/supplier-resource/system/user/doDelete',params).then((res) => {
                resolve(res.data);
            });
        }));
    },
    resetPwd({dispatch, commit}, params) {
        return new Promise(((resolve, reject) => {
            http.post('/supplier-resource/system/user/resetPwd',params).then((res) => {
                resolve(res.data);
            });
        }));
    },
    offlineUsers({dispatch, commit}, params) {
        return new Promise(((resolve, reject) => {
            http.post('/supplier-resource/system/user/offlineUsers',params).then((res) => {
                resolve(res.data);
            });
        }));
    },
    acceptAgreement({dispatch, commit}) {
        return new Promise(((resolve, reject) => {
            http.post('/supplier-resource/system/user/acceptAgreement',{}).then((res) => {
                resolve(res.data);
            });
        }));
    },
    compList({dispatch, commit}) {
        return new Promise(((resolve, reject) => {
            http.post('/supplier-resource/system/user/compList',{}).then((res) => {
                resolve(res.data);
            });
        }));
    },
    groupList() {
        return new Promise(((resolve) => {
            http.post('/supplier-resource/system/user/groupList',{}).then((res) => {
                resolve(res.data);
            });
        }));
    }
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};